import { GraphType, NodeType } from '@/utils/const'

function createLayout (dataBus, nodeOutList, config) {
    if (dataBus.graphType === GraphType.FLOW_TO_NODE) {
        return createLayoutTo(dataBus, nodeOutList, config)
    }
    let {
        rectWidth,
        svgWidth
    } = config

    let aloneNodeOutList = []
    let QnANodeOutList = []
    let happyNodeOutList = []
    for (let nodeOut of nodeOutList) {
        if (nodeOut.parent || nodeOut.children.length > 0) {
            happyNodeOutList.push(nodeOut)
        } else {
            if (nodeOut.data.intentList.length > 0) {
                QnANodeOutList.push(nodeOut)
            } else {
                aloneNodeOutList.push(nodeOut)
            }
        }
    }

    let maxX = -1
    let maxY = -1
    let column = []
    column.length = 100

    function loopTree (nodeOut, x, y) {
        if (nodeOut.x > -1) {
            return
        }
        nodeOut.x = x
        nodeOut.y = y
        maxX = Math.max(maxX, x)
        let lowestNode = column[x]
        if (lowestNode && lowestNode.y >= y) {
            moveNodeDown(nodeOut, lowestNode.y - y + 1)
        }
        column[x] = nodeOut
        if (nodeOut.open) {
            let childX = x + 1
            for (let i = 0; i < nodeOut.children.length; i++) {
                loopTree(
                    nodeOut.children[i],
                    childX,
                    i === 0 ? nodeOut.y : nodeOut.children[i - 1].y + 1
                )
            }
        }
    }

    function moveNodeDown (nodeOut, d) {
        if (!nodeOut) {
            return
        }
        nodeOut.y += d
        let parent = nodeOut.parent
        if (parent && parent.children[0] === nodeOut) {
            moveNodeDown(parent, d)
        }
    }

    for (let i = 0; i < 100; i++) {
        column[i] = null
    }
    let rootY = maxY + 1
    for (let i = 0; i < happyNodeOutList.length; i++) {
        if (!happyNodeOutList[i].parent) {
            loopTree(happyNodeOutList[i], 0, rootY)
            rootY++
        }
    }

    for (let nodeOut of nodeOutList) {
        maxY = Math.max(maxY, nodeOut.y)
    }
    // special node
    let rowSize = Math.floor(svgWidth / (rectWidth * 2))
    if (rowSize * rectWidth * 2 + rectWidth <= svgWidth) {
        rowSize += 1
    }
    // QnA node
    let qnaTextY = QnANodeOutList.length > 0 ? maxY + 1 : -2
    for (let i = 0; i < QnANodeOutList.length; i++) {
        let nodeOut = QnANodeOutList[i]
        nodeOut.x = i % rowSize * 2
        nodeOut.y = qnaTextY + Math.floor(i / rowSize) + 1
    }
    for (let nodeOut of nodeOutList) {
        maxX = Math.max(maxX, nodeOut.x)
        maxY = Math.max(maxY, nodeOut.y)
    }
    // independent node
    let aloneTextY = aloneNodeOutList.length ? maxY + 1 : -2
    for (let i = 0; i < aloneNodeOutList.length; i++) {
        let nodeOut = aloneNodeOutList[i]
        nodeOut.x = i % rowSize * 2
        nodeOut.y = aloneTextY + Math.floor(i / rowSize) + 1
    }
    for (let nodeOut of nodeOutList) {
        maxX = Math.max(maxX, nodeOut.x)
        maxY = Math.max(maxY, nodeOut.y)
    }
    // order node base on coordinate for toggling
    nodeOutList.sort((a, b) => a.x === b.x ? a.y - b.y : b.x - a.x)

    return {
        nodeList: nodeOutList,
        maxX,
        maxY,
        qnaTextY,
        aloneTextY
    }
}

function createLayoutTo (dataBus, nodeOutList) {
    if (nodeOutList.length === 1) {
        nodeOutList[0].x = 0
        nodeOutList[0].y = 0
        return {
            nodeList: nodeOutList,
            maxX: 0,
            maxY: 0,
            qnaTextY: -2,
            aloneTextY: -2
        }
    }
    let maxX = 2
    let maxY = -1
    let targetOut = null
    let loopCount = 0
    for (let nodeOut of nodeOutList) {
        if (nodeOut.data.id === dataBus.graphTypeData) {
            if (targetOut) {
                nodeOut.id = nodeOut.id + '-loop-' + loopCount
                loopCount++
            } else {
                targetOut = nodeOut
                continue
            }
        }
        if (nodeOut.type === NodeType.STEP) {
            nodeOut.x = 0
            nodeOut.y = ++maxY
        } else if (nodeOut.type === NodeType.CARD) {
            nodeOut.x = 1
            nodeOut.y = nodeOut.parent.y
        }
    }
    targetOut.x = 2
    targetOut.y = Math.floor(maxY / 2)
    return {
        nodeList: nodeOutList,
        maxX,
        maxY,
        qnaTextY: -2,
        aloneTextY: -2
    }
}

export default createLayout
